import React from 'react';
import {Link} from "react-router-dom";
import {Button, Modal, Text} from "@gravity-ui/uikit"
import ProjectStatus, {
    ProjectDate, ProjectForSchool, ProjectKeywords, ProjectVenue
} from "./utils"

import './ProjectCard.css'
import {DeleteButtonIcon, EditButtonIcon_Link} from "../Button/Button";
import {DeleteModal} from "../Modal/Modals";

function ProjectUserCard({children, project, onDelete}) {
    const [open, setOpen] = React.useState(false);

    const canEditProject = () => {
        return (project.status === 'submitted' || project.status === 'returned');
    }

    return (
        <div className="bmm-card project-card project-card-draft">
            <div className="project-card__pretitle">
                <div className="me-1">
                    <ProjectVenue venue={project.venue}/>
                </div>
                <div>
                    <ProjectForSchool is_for_schoolchildren={project.is_for_schoolchildren}/>
                    <ProjectStatus status={project.status}/>
                </div>
            </div>

            {canEditProject()
                ? <Link to={`${project.id}`} className="project-card__title">{project.name}</Link>
                : <Text className="project-card__title">{project.name}</Text>}

            <div className="project__keywords project-card__keywords">
                <ProjectKeywords keywords={project.keywords}/>
            </div>

            <div className="project-card__text" dangerouslySetInnerHTML={{__html: project.description}}/>

            <div className="project-card__subtitle">
                <div className="project-card__subtitle-date">
                    <ProjectDate date={new Date(project.created_on)}/>
                </div>
                {canEditProject() && <div className="group-btn">
                    <DeleteButtonIcon onClick={() => setOpen(true)}/>
                    <EditButtonIcon_Link to={`${project.id}`}/>
                </div>}
            </div>
            <DeleteModal type="проект" name={`${project.name}`}
                             onDelete={() => onDelete(project.id)}
                             open={open} setOpen={setOpen}/>
        </div>
    );
}

export default ProjectUserCard;